
<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        
        <!-- Bloque Principal de Contenido (Subido a la parte superior) -->
        <div class="main-content-wrapper">
          
        

          <!-- 2. Corona y MIS XV Justo Abajo de Melanie -->
          <div ref="misXvWrapperRef" class="mis-xv-container">
            <img
              ref="coronaRef"
              src="@/assets/corona.png"
              alt="Ornamento"
              class="ornamento-img"
            >
            <div class="mis-xv-text glowing">
              MIS XV
            </div>
          </div>
  <!-- 1. Nombre Melanie Arriba -->
          <div
            ref="nombreRef"
            class="nombre-principal"
          >
            Camila
          </div>
          <!-- 3. Fecha del Evento Abajo de Todo -->
          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const misXvWrapperRef = ref(null)
    const coronaRef = ref(null)

    onMounted(() => {

      /* 1. ANIMACIÓN DEL FONDO (Aparece rápido) */
      gsap.fromTo(fotoPortadaRef.value, 
        { opacity: 0, scale: 1.1 },
        {
          opacity: 1,
          scale: 1,
          duration: 1.2,
          ease: 'power2.out'
        }
      )

      /* 2. TIMELINE PARA EL TEXTO (Animación rapidísima y padrísima) */
      const tl = gsap.timeline({ delay: 0.4 })

      // Entrada espectacular de "Melanie" (Efecto revelado desde abajo con escala)
      tl.fromTo(nombreRef.value,
        { opacity: 0, y: 50, scale: 0.9, filter: 'blur(10px)' },
        { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1, ease: 'power4.out' }
      )

      // Entrada inmediata de Corona y MIS XV (Aparecen flotando juntos al instante)
      tl.fromTo(misXvWrapperRef.value.children,
        { opacity: 0, y: 30, scale: 0.8 },
        { 
          opacity: 1, 
          y: 0, 
          scale: 1, 
          duration: 0.8, 
          stagger: 0.15, 
          ease: 'back.out(1.5)' 
        },
        "-=0.6" // Se solapa con el final de "Melanie" para que no tarde nada
      )

      // Entrada de la Fecha
      gsap.to(fechaRef.value.children, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: 'power3.out',
        delay: 1.2
      })

      /* 3. EFECTO FLOTANTE CONTINUO (Corona + Texto) */
      gsap.to(misXvWrapperRef.value, {
        y: '-=6',
        duration: 2.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 1.5
      })
    })

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvWrapperRef,
      coronaRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-top: -9px;
  
  /* DEGRADADO BONITO: Oscuro arriba (0.65 de opacidad) y transparente abajo */
  background-image: 
    linear-gradient(to bottom, rgba(0, 0, 0, 0.756) 0%, rgba(0, 0, 0, 0.221) 40%, rgba(0, 0, 0, 0) 100%), 
    url('@/assets/4_3_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Se cambió de center a flex-start para mandar todo arriba */
  color: white;
  z-index: 2;
}

/* Contenedor central alineado arriba de forma ordenada */
.main-content-wrapper {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px; /* Margen superior elegante para que no toque el borde del celular/pantalla */
}

/* Estilo de Melanie */
.nombre-principal {
  font-family: 'CynthiaJuneJF', serif;
  font-size: 85px;
  font-weight: 500;
  line-height: 0.9;
  color: #ffffff;
  text-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  will-change: transform, opacity;
}

/* Contenedor compacto para Corona y MIS XV justo debajo de Melanie */
.mis-xv-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -15px; /* Controla qué tan cerca está de Melanie */
  margin-bottom: 25px; /* Espacio antes de la fecha */
  will-change: transform;
}

.ornamento-img {
  width: 45px;
  filter: brightness(0) invert(1) drop-shadow(0px 2px 5px rgba(0,0,0,0.3));
  margin-bottom: 6px;
  opacity: 0; /* Lo maneja GSAP */
}

.mis-xv-text {
  font-family: 'file';
  font-size: 22px;
  letter-spacing: 2px;
  color: white;
  text-transform: uppercase;
  opacity: 0; /* Lo maneja GSAP */
}

/* Fecha en la parte inferior del bloque */
.fecha-evento {
  color: white;
  font-size: 18px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(15px);
}

.glowing {
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.6);
}
</style>

```